import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'superscripe',
    standalone: false
})
export class SuperscripePipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value) {
            return value.replace(/[™®©\u00ae\u00a9\u2122](?!<\/sup>)/g, '<sup>$&</sup>');
        }
    }

}
